<template>
  <div class="detail-container">
    <main>
      <div class="header">
        <span v-on:click="gotoHome">
          <span class="header1">BITMAX&nbsp;</span>
          <span class="header2">마음의소리</span>
        </span>
        <router-link to="/create" class="createBtn"
          ><img src="../../../src/assets/images/create.png" class="header-icon"
        /></router-link>
      </div>

      <div class="detail-header">
        <span class="d-a"><img src="../../assets/images/account.png" class="d-account"/></span>
        <span class="d-name"><b>익명</b></span>

        <span
          v-if="
            article.userId === userId &&
              (article.cc === 0 || article.cc === undefined) &&
              article.like < 10 &&
              article.commentCount < 10
          "
          class="ddropdown"
        >
          <button class="dropbtn">
            <img src="../../../src/assets/images/dropdown.png" class="dropdown" />
          </button>
          <div class="dropdown-content">
            <div @click="alterArticle">수정</div>
            <div @click="reset">삭제</div>
          </div>
        </span>
        <span v-else></span>
      </div>

      <div class="detail-body">
        <div class="d-content">{{ article.content }}</div>
      </div>

      <div class="d-updateDT">{{ article.createDT }}</div>

      <comment-component :commentList="commentList" :article="article"></comment-component>
    </main>
    <modal-component
      title="게시글을 삭제하시겠어요?"
      :articleID="article.id"
      :show="show"
      @close="show = false"
    ></modal-component>
  </div>
</template>

<script>
import Comment from './comment/Comment';
import firebase from 'firebase/app';
import Modal from '../modal/Modal';
// import {userId} from '../../const'
import { getTimeStamp } from '../../api';
import axios from 'axios';

export default {
  name: 'Detail',
  components: {
    'comment-component': Comment,
    'modal-component': Modal,
  },
  props: ['id'],
  data: function() {
    return {
      userId: localStorage.getItem('userId'),
      article: '',
      pg: this.$route.query.pg,
      commentList: [],
      like: 0,
      unLike: 0,
      show: false,
      commentCount: 0,
      showMenu: false,
    };
  },
  watch: {
    $route: function(to, from) {
      //to가 내가 앞으로 갈곳 from이 지금 있는 곳
      this.getArticle();
      this.getCommentList();
    },
  },
  mounted() {
    // this.getIpClient();
    this.getArticle();
    this.getCommentList();
  },
  computed: {},
  methods: {
    gotoHome() {
      this.$router.push({ name: 'Home' });
    },
    checkLike(id) {
      return Number(localStorage.getItem(id));
    },
    getArticle() {
      firebase
        .database()
        .ref('article')
        .child(this.id)
        .on('value', data => {
          var article = data.val();
          var id = data.key; //key값 id에 담아주기
          article.id = id;
          var comment = article.comment;
          var cc = 0;
          var commentCount = 0;
          if (comment != undefined) {
            commentCount = Object.keys(comment).length;
            var comment_list = Object.values(comment);
            for (var i = 0; i < Object.keys(comment).length; i++) {
              if (comment_list[i].userId !== localStorage.getItem('userId')) {
                cc = cc + 1;
              }
            }
          }
          article.cc = cc;
          article.commentCount = commentCount;
          if (article.like >= 10 || article.commentCount >= 10) {
            article.waiting = 1;
          }
          this.article = article;
        });
    },
    alterArticle() {
      this.toggleShow();
      this.$router.push({ name: 'Create', params: { article: this.article } });
    },
    getCommentList() {
      firebase
        .database()
        .ref('article/' + this.id + '/comment')
        .orderByKey()
        .on('value', snapshot => {
          this.commentList = [];
          snapshot.forEach(childSnapshot => {
            var childData = childSnapshot.val();
            var id = childSnapshot.key;
            childData.id = id;
            if (localStorage.getItem('userId') == null) this.commentCount += 1;
            childData.alter = 0;
            this.commentList.push(childData);
          });
        });
    },
    createLike(article) {
      let isLiked = localStorage.getItem(article.id);
      if (Number(isLiked)) {
        localStorage.removeItem(article.id);
        firebase
          .database()
          .ref('article/')
          .child(article.id)
          .update({
            like: article.like - 1,
            updateDT: getTimeStamp(),
          });
      } else {
        localStorage.setItem(article.id, 1);
        firebase
          .database()
          .ref('article/')
          .child(article.id)
          .update({
            like: article.like + 1,
            updateDT: getTimeStamp(),
          });
      }
    },
    toggleShow() {
      this.showMenu = !this.showMenu;
    },
    reset() {
      this.show = true;
      this.showMenu = !this.showMenu;
    },
    backtoList() {
      // this.$router.push({ name: "Home", query: { pg: this.pg } })
      this.$router.push('/');
    },
    // async getIpClient() {
    //   try {
    //     const response = await axios.get('https://api.ipify.org?format=json');
    //     if (response.data.ip !== '121.134.136.28' && response.data.ip !== '125.131.77.43') {
    //       await this.$router.push({ name: 'NotAccess' });
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
  },
};
</script>

<style scoped>
@import 'Detail.scss';
</style>
